// import { RootStore } from 'mobx-stores'
import { PaginationSearchBase, TriggerSearchFunc } from 'mobx-stores/utils'
import { CustomerAggregateDTO } from 'models/customers'
import { Api } from 'services'
import {
  CustomersTableSearchProps,
  CustomersTableSortProps,
  GenderSelect,
} from './customers-table-store.types'
import {
  customersTableNeedTimeoutSearchProps, initialCustomersTableSearchProps, initialDepartmentsTablePaginationProps
} from './customers-table-store.utils'

import {
  SelectOption,
} from '@touche-lts/panel-ui/dist'

export class CustomersTableStore extends PaginationSearchBase<
  CustomersTableSortProps,
  CustomersTableSearchProps,
  CustomerAggregateDTO
> {
  private customersApi: Api['customersApi']

  constructor(rootStore: any) {
    super({
      initialPaginationProps: initialDepartmentsTablePaginationProps,
      initialSearchProps: initialCustomersTableSearchProps,
      needTimeoutProps: customersTableNeedTimeoutSearchProps
    })
    this.customersApi = rootStore.generalStore.api.customersApi
  }



  // METHODS

  public formatPhoneNumber = (phoneNumber): string => {
    let cleaned = ('' + phoneNumber).replace(/\D/g, '');
    let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `+ ${match[1]} ${match[2]} ${match[3]}`;
    }
    if(phoneNumber)
     return '+ ' + phoneNumber;
    else
      return ' ';
  };

  public formatFullname = (firstName, lastName): string => {
    var fullName = '';
    if(firstName)
      fullName = fullName + firstName;
    if(lastName)
      fullName = fullName + ' ' + lastName;
    return fullName;
  };

  public triggerSearch: TriggerSearchFunc = async (options): Promise<void> => {
    const data = await this.customersApi.allFilteredSorted(this.storeFilter, {
      pageQueryParams: {
        page: options?.resetPageNumber ? 0 : this.pagination.page,
        size: this.pagination.size,
        sortDirection: this.pagination.sortDirection,
        sortProp: this.pagination.sortProp
      }
    })
    if (!data) return
    this.handleSearchResultPaginationProps(data)
    this.setSearchResults(data.content);
  }

  // COMPUTED
  private get storeFilter(): CustomersTableSearchProps {
    return {
      raitingsMin: this.searchProps.raitingsMin,
      raitingsMax: this.searchProps.raitingsMax,
      revenueTotalMin: this.searchProps.revenueTotalMin,
      revenueTotalMax: this.searchProps.revenueTotalMax,
      emailAddress: this.searchProps.emailAddress,
      registeredOn: this.searchProps.registeredOn,
      gender: this.searchProps.gender,
      phoneNumber: this.searchProps.phoneNumber,
      fullName: this.searchProps.fullName,
      dateOfBirth: this.searchProps.dateOfBirth,
      orderStatus: this.searchProps.orderStatus,
      orderDate: this.searchProps.orderDate,
      order: this.searchProps.order,
    }
  }

  public get genderSelect(): SelectOption<GenderSelect>[] {
    return Object.values(GenderSelect).map(type => ({
      label: type,
      value: type
    }))
  }
}




